import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comslow',
  templateUrl: './comslow.component.html',
  styleUrls: ['./comslow.component.css']
})
export class ComslowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
